import React from 'react'
import ReactDOM from 'react-dom';

import {put, select, takeEvery, takeLeading} from 'redux-saga/effects'
import * as actions from '../actions/index';
import * as actionTypes from '../actions/actionTypes';

//Components
import Notification from '../../components/Notifications/Notifications';

//Utils
import qs from 'qs';
import axios from '../../services/axios-client';

export function* getPaymentOptions(action) {
    try {
        yield put(actions.getPaymentOptionsFailed(null));
        yield put(actions.getPaymentOptionsSucceeded(null));
        const userToken = yield select(state => state.auth.userToken);
        const companyKey = yield select(state => state.auth.companyKey);
        const data = {
            'solarium_id': action.roomId,
            'package_id': action.serviceId,
            'timestamp': action.timestamp
        };
        const response = yield axios.request({
            data: qs.stringify(data),
            method: 'post',
            url: '/api/payment/options/get',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken
            },
        });
        yield put(actions.getPaymentOptionsSucceeded(response.data.result));
    } catch (error) {
        if (error.response && error.response.data && error.response.data.code === 401) {
            yield put(actions.logout());
            return;
        }

        if (error.response && error.response.data && error.response.data.result) {
            const {message} = error.response.data.result;
            yield put(actions.getPaymentOptionsFailed(message));
            return;
        }

        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export function* confirmPayment(action) {
    const {
        roomId,
        serviceId,
        timestamp,
        paymentType,
        onlinePayment,
        idealBankId,
        history,
        url,
     } = action.payload;

    try {
        const {userToken, companyKey} = yield select(state => state.auth);
        if(!userToken || !companyKey) {
            return;
        }

        const response = yield axios.request({
            method: 'POST',
            url: '/api/payment/create-and-confirm',
            data: qs.stringify({
                solarium_id: roomId,
                package_id: serviceId,
                timestamp: timestamp,
                payment_type: paymentType,
                ideal_bank_id: idealBankId,
                from_web: 1,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken
            }
        });

        const paymentUrl = response.data.result.mollie_url;
        const id = response.data.result.booking_id;

        if (response.status === 200) {
            yield put(actions.confirmPaymentSucceeded({ id, paymentType, onlinePayment }));

            if (paymentUrl) {
                const popup_window = window.open(paymentUrl, '_blank');

                if (!popup_window) {
                    yield put(actions.setPaymentUrl(paymentUrl));
                    return;
                }
            }
            
            history.push(url);
            yield put(actions.getProfile());
        }
    } catch (err) {
        yield put(actions.confirmPaymentError(err?.response?.data?.result?.message));

        ReactDOM.render(
            <Notification type='error' error={err}/>,
            document.getElementById('notification')
        );
    }
}

export function* cancelPayment({id}) {
    try {
        const userToken = yield select(state => state.auth.userToken);
        const companyKey = yield select(state => state.auth.companyKey);

        yield axios.request({
            method: 'POST',
            url: '/api/payment/cancel/booking',
            data: qs.stringify({
                booking_id: id
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken
            }
        });
    } catch (err) {
        ReactDOM.render(
            <Notification type='error' error={err}/>,
            document.getElementById('notification')
        );
    }
}

export function* checkPaymentStatus({id}) {
    try {
        const userToken = yield select(state => state.auth.userToken);
        const companyKey = yield select(state => state.auth.companyKey);

        
        yield axios.request({
            method: 'POST',
            url: '/api/payment/check-status/booking',
            data: qs.stringify({
                booking_id: id
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken
            }
        });
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export const watchPayment = [
    takeEvery(actionTypes.GET_PAYMENT_OPTIONS, getPaymentOptions),
    takeLeading(actionTypes.CONFIRM_PAYMENT, confirmPayment),
    takeEvery(actionTypes.CANCEL_PAYMENT, cancelPayment),
    takeEvery(actionTypes.CHECK_PAYMENT_STATUS, checkPaymentStatus)
];
